import React, { useMemo } from 'react';
import { useLoaderData } from 'react-router-dom';
import {useTranslation, Trans } from "react-i18next";
import ContentSection from '../../components/common/ContentSection/ContentSection';
import DatasetGrid from '../../components/datasets/DatasetGrid/DatasetGrid';
import type { DatasetsLoaderData } from '../../loaders/datasetsLoader';
import './Datasets.css';
import { useLocalizationLabels } from '../../context/LocalizationLabelContext';

const Datasets = () => {
    const { t } = useTranslation("datasets");
    const { datasets } = useLoaderData() as DatasetsLoaderData;

    const {
        organOptionLabels,
        municipalityNameOptionLabels,
    } = useLocalizationLabels();

    const localizedDatasets = useMemo(() => {
        return datasets.map((item) => {

            const localizedMunicipalityName =
                item.municipalityId
                    ? municipalityNameOptionLabels[item.municipalityId]?.label ?? item.municipalityTextId
                    : item.municipalityTextId;

            const localizedBodyName =
                item.bodyCode
                    ? organOptionLabels[item.bodyCode]?.label ?? item.bodyCode
                    : '';

            const localizedTitle = [
                localizedMunicipalityName,
                localizedBodyName,
                item.termFrom != null && item.termTo != null ? `${item.termFrom}-${item.termTo}` : ''
            ].filter(Boolean).join(' ');

            return {
                ...item,
                title: localizedTitle
            };
        });
    }, [datasets, municipalityNameOptionLabels, organOptionLabels]);
    return (
        <div className="datasets-page">
            {/*TODO: add datasets texts*/}
            {/*<ContentSection title="Nadpis úroveň 1" level={1} />*/}
            {/*<ContentSection title="Nadpis úroveň 2" level={2} />*/}
            {/*<ContentSection title="Nadpis úroveň 3" level={3} />*/}
            {/*<ContentSection title="Nadpis úroveň 4" level={4} />*/}
            {/*<ContentSection title="Nadpis úroveň 5" level={5} />*/}
            {/*<ContentSection title="Nadpis úroveň 6" level={6} />*/}

            {/*<ContentSection title="Význam datových sad" level={1}>*/}
            {/*    <p>*/}
            {/*        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore*/}
            {/*        et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.*/}
            {/*    </p>*/}
            {/*    <p>*/}
            {/*        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla*/}
            {/*        pariatur.*/}
            {/*    </p>*/}
            {/*    <ContentSection title="Proces zpracování dat" level={2}>*/}
            {/*    <p>*/}
            {/*        <span className="hl-italic hl-purple">Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span>{' '}*/}
            {/*        Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id*/}
            {/*        est laborum.*/}
            {/*    </p>*/}
            {/*    <p>*/}
            {/*        Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.{' '}*/}
            {/*        <span className="hl-italic hl-purple">Excepteur sint occaecat cupidatat non proident</span>.*/}
            {/*    </p>*/}
            {/*    <p>*/}
            {/*        Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.{' '}*/}
            {/*        <span className="hl-underline hl-italic hl-purple">totam rem aperiam,</span>{' '}*/}
            {/*        <span className="hl-underline hl-italic hl-purple">eaque ipsa quae ab illo inventore veritatiset</span>.*/}
            {/*    </p>*/}
            {/*    </ContentSection>*/}
            {/*</ContentSection>*/}

            <ContentSection title={t('datasets')} level={1} subtitle={t('datasetsTooltip')}>
                <DatasetGrid datasets={localizedDatasets} />
            </ContentSection>

            <ContentSection title={t('sourceInfo.dataSources')} level={1}>
                <p>{t('sourceInfo.description')}</p>
                <p>
                    <Trans 
                        t={t} 
                        i18nKey="sourceInfo.integrityWarning" 
                        components={[<span className="hl-bold" key="0" />]} 
                    />
                </p>
            </ContentSection>
        </div>
    );
};

export { Datasets };
